export default __webpack_public_path__ + "static/media/slide2.ba0ff4b5.jpg";